// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__3zCEp","infoBtn":"quickbooks_infoBtn__1UGZ1","formBox":"quickbooks_formBox__Za4Q8","formFooter":"quickbooks_formFooter__1rAd6"};